import { render } from "./SolucaoModalAlterarSituacao.vue?vue&type=template&id=d35deabc"
import script from "./SolucaoModalAlterarSituacao.vue?vue&type=script&lang=js"
export * from "./SolucaoModalAlterarSituacao.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__